// extracted by mini-css-extract-plugin
export default {"tagInputWrapper":"AddNewInlineItem-module__tagInputWrapper___hausa","addNewTagIcon":"AddNewInlineItem-module__addNewTagIcon___O3Heq"};